import { Spacing } from "components/designV2/constants";
import styled from "styled-components";

export const TabsWrapper = styled.div`
  margin-bottom: ${Spacing.md}px;
`;
